// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__1XV0i","title":"Images45_title__FY3Qd","images":"Images45_images__1tiID"};